import React, { useState, useEffect } from 'react'
import { supabase } from './supabaseClient'
import Login from './screens/Login'
import Dashboard from './screens/Dashboard'
import './App.css'

function App() {
  const [session, setSession] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      setLoading(false)
    })
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => setSession(session)
    )
    return () => subscription.unsubscribe()
  }, [])

  if (loading) return (
    <div style={{ display: 'flex', justifyContent: 'center', 
      alignItems: 'center', height: '100vh', fontFamily: 'Arial' }}>
      <p style={{ color: '#185FA5' }}>Loading...</p>
    </div>
  )

  return (
    <div className="App">
      {session ? <Dashboard session={session} /> : <Login />}
    </div>
  )
}

export default App